// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"src_views_home_index_vue":"31ae2b4fae","src_views_product_index_vue":"6ab7e23a88","src_views_about_index_vue":"d739d6731c","src_views_join_index_vue":"c027f83426","src_views_contact_index_vue":"22c9330183"}[chunkId] + ".chunk.css";
};